import {SharedCollection} from '../../@types/wishlist.js';
import {AbstractApi} from './abstract-api.js';

export class CuratedCollectionApiInstance extends AbstractApi {
  async addTopCustomers(endpoint: string, collectionId: string, bocaIds: string[]) {
    return this.post(endpoint, 'Curated Collection', {
      collectionId,
      bocaIds
    });
  }

  async removeTopCustomer(endpoint: string, collectionId: string, bocaId: string) {
    return this.delete(endpoint, 'Curated Collection', {
      collectionId,
      bocaIds: [bocaId]
    });
  }

  async getCollections(endpoint: string): Promise<SharedCollection[]> {
    return this.get(endpoint, 'Curated Collection');
  }
}

export const curatedCollectionApi = new CuratedCollectionApiInstance();
